export class CartAbandonmentHeartbeatAPIRequestPromoCodes {
    static of(props) {
        const data = [];
        for (const [, value] of Object.entries(props)) {
            value.map(({ promoCodes }) => data.push(promoCodes));
        }
        return data;
    }
}
